const apiKey = 'efb245a82054f1ba160074dcf331589e';

export { apiKey };
